import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core";

@Directive({
	selector: "[click.stop]",
})
export class ClickStopDirective {
	@Output("click.stop") stopEvent = new EventEmitter();

	constructor() {}
	@HostListener("click", ["$event"])
	onHostElementClick(ev: Event) {
		ev.stopPropagation();
		this.stopEvent.emit(...arguments);
	}
}
